import { get, post } from '@/api/index'

// https://ecapi.yinmakeji.com/api/h5app/wxapp/promotion/sf/orderlist
export const sfList = params => {
  return get('https://ecapi.yinmakeji.com/api/h5app/wxapp/promotion/sf/orderlist', params)
}
// https://ecapi.yinmakeji.com/api/h5app/wxapp/promotion/sf/order
export const sfDetail = params => {
  return get('https://ecapi.yinmakeji.com/api/h5app/wxapp/promotion/sf/order', params)
}
// https://ecapi.yinmakeji.com/api/h5app/wxapp/promotion/sf/order/new
export const addSf = params => {
  return post('https://ecapi.yinmakeji.com/api/h5app/wxapp/promotion/sf/order/new', params)
}
// https://ecapi.yinmakeji.com/api/h5app/wxapp/promotion/sf/price
export const checkPrice = params => {
  return post('https://ecapi.yinmakeji.com/api/h5app/wxapp/promotion/sf/price', params)
}
// https://ecapi.yinmakeji.com/api/h5app/wxapp/promotion/sf/order/cancel
export const cancelOrder = params => {
  return post('https://ecapi.yinmakeji.com/api/h5app/wxapp/promotion/sf/order/cancel', params)
}
// https://ecapi.yinmakeji.com/api/h5app/wxapp/promotion/sf/order/pay
// 支付订单
export const payOrder = params => {
  return post('https://ecapi.yinmakeji.com/api/h5app/wxapp/promotion/sf/order/pay', params)
}
